<template>
    <mails v-if="disputeLetterStore.display == 1"></mails>
    <show v-else-if="disputeLetterStore.display == 2"></show>
</template>

<script>
    import { useDisputeLetterStore } from '../../stores/DisputeLetterStore.js'
    import Mails from './Mails.vue'
    import Show from './Show.vue'
    export default {
        components: {
            Mails,
            Show
        },
        mounted() {
        },
        setup(props) {
            return {
                disputeLetterStore: useDisputeLetterStore(),
            }
        }
    }
</script>
